import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + "/admin/tongue-twisters",
  headers: {
    Authorization: `Bearer ${getToken()}`,
    "Content-Type": "application/json",
  },
});

export const fetchAllTwisters = async () => {
  try {
    const res = await api.get("");
    return { status: res.status, data: res.data };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      message: err.message
    };
  }
};

export const createTwister = async (data) => {
  try {
    const res = await api.post("", data);
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: 500, message: err.message };
  }
};

export const updateTwister = async (id, data) => {
  try {
    const res = await api.put(`/${id}`, data);
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: 500, message: err.message };
  }
};

export const publishTwister = async (id) => {
  try {
    const res = await api.patch(`/${id}/publish`);
    return { status: res.status };
  } catch (err) {
    return { status: 500, message: err.message };
  }
};

export const unpublishTwister = async (id) => {
  try {
    const res = await api.patch(`/${id}/unpublish`);
    return { status: res.status };
  } catch (err) {
    return { status: 500, message: err.message };
  }
};

export const deleteTwister = async (id) => {
  try {
    const res = await api.delete(`/${id}`);
    return { status: res.status };
  } catch (err) {
    return { status: 500, message: err.message };
  }
};